(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.querySelector('.quick-view-modal');
    var overlay = document.querySelector('[data-quick-view-overlay]');
    if (!modal || !overlay) return;

    var content = modal.querySelector('.quick-view-modal__content');
    var cache = {};

    function openModal() {
      document.body.classList.add('quick-view-modal--open');
      overlay.classList.add('is-active');
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
    }

    function closeModal() {
      document.body.classList.remove('quick-view-modal--open');
      overlay.classList.remove('is-active');
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
    }

    function setLoading(isLoading) {
      modal.classList.toggle('is-loading', isLoading);
    }

    function showError(message) {
      content.innerHTML =
        '<p style="padding:20px;text-align:center;">Unable to load product details. Please try again.</p>' +
        (message
          ? '<pre style="padding:12px;margin:0 12px;background:#fff;color:#b00;font-size:12px;white-space:pre-wrap;word-break:break-word;border:1px solid #eee;border-radius:4px;">' +
            message +
            '</pre>'
          : '');
    }

    // Re-execute every <script> inside a container so that inline/external
    // scripts (registered custom elements, product-form init, etc.) run in
    // the context of the newly injected markup.
    function reExecuteScripts(container) {
      container.querySelectorAll('script').forEach(function (oldScript) {
        var newScript = document.createElement('script');
        Array.prototype.slice.call(oldScript.attributes).forEach(function (attr) {
          newScript.setAttribute(attr.name, attr.value);
        });
        if (!oldScript.src && oldScript.textContent) {
          newScript.textContent = oldScript.textContent;
        }
        oldScript.parentNode.replaceChild(newScript, oldScript);
      });
    }

    function extractProductMain(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      return doc.querySelector('.product-main');
    }

    function injectMarkup(productMain) {
      content.innerHTML = '';
      content.appendChild(productMain);
      reExecuteScripts(content);
      if (typeof window.reinitSellingPlans === 'function') {
        window.reinitSellingPlans();
      }
    }

    function loadProduct(url) {
      if (!url) return;
      openModal();

      if (cache[url]) {
        var cachedMain = extractProductMain(cache[url]);
        if (cachedMain) {
          injectMarkup(cachedMain);
          setLoading(false);
          return;
        }
        delete cache[url];
      }

      setLoading(true);
      content.innerHTML = '';

      fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      })
        .then(function (res) {
          if (!res.ok) {
            throw new Error('Request failed: ' + res.status + ' ' + res.statusText);
          }
          return res.text();
        })
        .then(function (html) {
          var main = extractProductMain(html);
          if (!main) {
            throw new Error('.product-main not found in response');
          }
          cache[url] = html;
          injectMarkup(main);
          setLoading(false);
        })
        .catch(function (err) {
          console.error('[quick-view]', err);
          showError(
            (err && err.message ? err.message : String(err)) + '\nURL: ' + url,
          );
          setLoading(false);
        });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.product-card__cta--quick-view');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        loadProduct(trigger.getAttribute('data-quick-view-url'));
        return;
      }

      if (e.target.closest('[data-quick-view-close]')) {
        closeModal();
        return;
      }

      if (e.target === overlay) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-active')) {
        closeModal();
      }
    });

    // Close the Quick View as soon as the cart drawer opens. The theme
    // uses two different triggers, so we watch both:
    //   1. The AJAX cart toggles `.cart-drawer--show` on <body>.
    //   2. The native <cart-drawer> element receives `.active`.
    if (typeof MutationObserver !== 'undefined') {
      var maybeClose = function () {
        if (!modal.classList.contains('is-active')) return;

        var bodyOpen = document.body.classList.contains('cart-drawer--show');
        var cartDrawer = document.querySelector('cart-drawer');
        var drawerOpen = cartDrawer && cartDrawer.classList.contains('active');

        if (bodyOpen || drawerOpen) closeModal();
      };

      new MutationObserver(maybeClose).observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
      });

      var cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl) {
        new MutationObserver(maybeClose).observe(cartDrawerEl, {
          attributes: true,
          attributeFilter: ['class'],
        });
      }
    }
  });
})();
